export default "<div id=\"topBar\">\r\n    <bart-administrator-menu></bart-administrator-menu>\r\n  </div>"